import { ICTema } from "../../../interfaces/catalogos.";

export const CAT_ROLES = [
  { label: "Administrador", rol: 4 },
  { label: "Coordinador", rol: 3 },
  { label: "Supervisor", rol: 2 },
  { label: "Analista", rol: 1 },
];

export const CAT_PERMISOS: ICTema[] = [
  { descripcion: "Corporativo Confidencial", rol: 1 },
  { descripcion: "Personal", rol: 2 },
  { descripcion: "Personal Confidencial", rol: 3 },
  { descripcion: "Corporativo", rol: 4 },
];

export const CAT_ACCIONES = [
  { label: "Lectura", accion: 1 },
  { label: "Escritura", accion: 2 },
  { label: "Ambos", accion: 3 },
];
